import React from 'react';
import { observer } from 'mobx-react';
import classes from 'classnames';
import FormControl from '@mui/material/FormControl';
import { useTranslation } from 'react-i18next';
import AnswerableCheckbox from './check-box';
import { QuestionHeading } from './question-heading';

export const CheckBoxes = observer(({ ui, handleChange, value, answer }) => {
    const { t } = useTranslation('assessment');

    const onChange = (event, boxVal) => {
        let val = [...(value || [])];

        if (event.target.checked) {
            if (!val.includes(boxVal)) val.push(boxVal);
        } else {
            val = val.filter((x) => x !== boxVal);
        }
        handleChange(val, null, null, true);
    };

    return (
        <div className="section-exam">
            <div className={classes('assessment')}>
                <div className={'assessment-question'}>
                    <QuestionHeading ui={ui} />
                    <FormControl component="fieldset">
                        {ui.options.map((v, i) => {
                            return (
                                <AnswerableCheckbox
                                    onChange={onChange}
                                    groupValue={value}
                                    key={'checkbox-' + i}
                                    value={v.value}
                                    text={v.text}
                                    answer={answer}
                                />
                            );
                        })}
                    </FormControl>
                </div>
            </div>
        </div>
    );
});
